var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"merge-form face-list"},_vm._l((_vm.filteredFaces),function(face){return _c('FaceCover',{key:face.basename,attrs:{"base-name":face.basename,"small":""},on:{"click":function($event){return _vm.handleSelect(face.basename)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }